import { faList, faTable } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import ModalWindow from "../UI/ModalWindow";
import Pagination from "../UI/Pagination";
import GranularPermissionModal from "../Permissions/GranularPermissionModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FilterStudentModal from "./FilterStudentModal";
import { axiosPost } from "../../utils/AxiosApi";
import {
  faAddressCard,
  faBook,
  faLocationDot,
  faMarsAndVenus,
  faSchool,
  faUser,
  faIdCardClip,
} from "@fortawesome/free-solid-svg-icons";
import {
  URL,
  checkRolePermissions,
  checkWidgetAdminOrNot,
} from "../../utils/Constants";
import { Spinner } from "reactstrap";
import StudentFlipCard from "./StudentFlipCard";
import StudentTableRow from "./StudentTableRow";
import StudentCard from "./StudentCard";

const initialData = {
  class: "",
  section: "",
  studentName: "",
  admissionStatus: "ASSIGNED",
  gender: "",
  admissionDate: "",
  academicYear: "",
  age: [1, 30],
  guardian: "",
};

const StudentsList = () => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(12);
  const [totalRecords, setTotalRecords] = useState(0);
  const [studentsData, setStudentsData] = useState(null);
  const [classroom, setClassroom] = useState(null);
  const [permissionModal, setPermissionModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [activeView, setActiveView] = useState(() => {
    const defaultView = localStorage.getItem("view");
    return defaultView ? JSON.parse(defaultView) : "cards";
  });
  const [filterData, setFilterData] = useState(initialData);
  const [menuRowId, setMenuRowId] = useState(null);

  useEffect(() => {
    getAllStudents();
    getClassRoom();
  }, []);

  const handleViewChange = (view) => {
    setActiveView(view);
    localStorage.setItem("view", JSON.stringify(view));
  };

  const getAllStudents = (page = currentPage, filters = filterData) => {
    let currentPagevar = page - 1;
    const params = {
      classRoom: parseInt(filters.section),
      yearLevel: parseInt(filters.class),
      status: filters.admissionStatus,
      gender: filters.gender,
      academicSession: filters.academicYear,
      dateOfAdmission: filters.admissionDate,
      studentName: filters.studentName,
      guardianName: filters.guardian,
      ageMin: parseInt(filters.age[0]),
      ageMax: parseInt(filters.age[1]),
      limit: pageSize,
      offset: currentPagevar,
    };
    setLoading(true);
    axiosPost(URL.students, params, (response) => {
      if (response.status === 200) {
        const results = response.data.data;
        const totalRecords = response.data.totalRecordsCount;
        setStudentsData(results);
        setTotalRecords(totalRecords);
      }
      setLoading(false);
    });
  };

  const getClassRoom = () => {
    axiosPost(URL.selectClassroom, {}, (response) => {
      if (response.status == 200) {
        const results = response.data.data;
        setClassroom(results);
      }
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getAllStudents(page);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      getAllStudents(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalRecords / pageSize) {
      setCurrentPage(currentPage + 1);
      getAllStudents(currentPage + 1);
    }
  };

  const handleFilterFormSubmit = () => {
    setCurrentPage(1);
    getAllStudents(1);
    setFilterModal((prev) => !prev);
  };

  const handleResetFilter = () => {
    setFilterData(initialData);
    setCurrentPage(1);
    getAllStudents(1, initialData);
  };

  const toggleMenu = (rowId) => {
    setMenuRowId((prev) => (prev === rowId ? null : rowId));
  };

  return (
    <>
      <section className="students-container">
        <div className="header flex">
          <h4 className="heading">Students List</h4>
          <div className="flex header-btns">
            <div className="flex view-btn">
              <button
                className={`${activeView === "cards" ? "active" : ""} icon-btn`}
                onClick={() => handleViewChange("cards")}
              >
                <FontAwesomeIcon title="cardBtn" icon={faList} />
              </button>
              <button
                className={`${
                  activeView === "tabular" ? "active" : ""
                } icon-btn`}
                onClick={() => handleViewChange("tabular")}
              >
                <FontAwesomeIcon title="tableBtn" icon={faTable} />
              </button>
            </div>

            <button
              disabled={loading}
              className="secondary-btn"
              onClick={handleResetFilter}
            >
              Reset Filter
            </button>

            <button
              className="secondary-btn"
              onClick={() => setFilterModal((prev) => !prev)}
            >
              Filter
            </button>

            {checkWidgetAdminOrNot("Students") === true && (
              <button
                className="primary-btn"
                onClick={() => setPermissionModal((prev) => !prev)}
              >
                Permission
              </button>
            )}
          </div>
        </div>

        {loading ? (
          <div className="students-spinner">
            <div className="loader">
              <Spinner color="primary"></Spinner>
            </div>
            <div style={{ fontSize: "16px", marginTop: "15px" }}>
              Please wait !! Processing.....
            </div>
          </div>
        ) : null}

        {!loading && activeView === "cards" && (
          <ul title="Student Cards" className="students-list">
            {studentsData?.map((student) => (
              <li key={student.admissionId}>
                <StudentFlipCard
                  refetchStudents={getAllStudents}
                  student={student}
                  toggleMenu={toggleMenu}
                  menuRowId={menuRowId}
                  setMenuRowId={setMenuRowId}
                />
                {/* <StudentCard
                  refetchStudents={getAllStudents}
                  student={student}

                /> */}
              </li>
            ))}
          </ul>
        )}

        {!loading && activeView === "tabular" && (
          <div title="Student Table" className="table-wrapper">
            <table className="table students-table">
              <thead>
                <tr className="tr-head">
                  <th>
                    <FontAwesomeIcon icon={faUser} />
                    <span>Name</span>
                  </th>
                  <th>
                    <FontAwesomeIcon icon={faIdCardClip} />
                    <span>Roll Number</span>
                  </th>
                  <th>
                    <FontAwesomeIcon icon={faAddressCard} />
                    <span>Registration Number</span>
                  </th>
                  <th>
                    <FontAwesomeIcon icon={faMarsAndVenus} />
                    <span>Gender</span>
                  </th>
                  <th>
                    <FontAwesomeIcon icon={faSchool} />
                    <span>Class</span>
                  </th>
                  <th>
                    <FontAwesomeIcon icon={faBook} />
                    <span>Section</span>
                  </th>
                  <th>
                    <FontAwesomeIcon icon={faLocationDot} />
                    <span>Address</span>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {studentsData?.map((student) => {
                  return (
                    <StudentTableRow
                      refetchStudents={getAllStudents}
                      key={student.admissionId}
                      student={student}
                      toggleMenu={toggleMenu}
                      menuRowId={menuRowId}
                      setMenuRowId={setMenuRowId}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {!studentsData ||
          (studentsData.length === 0 && (
            <div className="empty-data">No Data Found</div>
          ))}

        <div
          role="pagination"
          aria-label="student-pagination"
          className="modern-pagination"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "48px",
          }}
        >
          <Pagination
            type="modern"
            itemsCount={totalRecords}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            nextPage={handleNextPage}
            previousPage={handlePreviousPage}
          />
        </div>
      </section>

      <ModalWindow
        modal={permissionModal}
        toggleModal={() => setPermissionModal((prev) => !prev)}
        modalHeader={"Assign permission to user"}
        size="lg"
        id="tt-permissionModal"
        modalBody={
          <GranularPermissionModal
            widgetName={"Students"}
            moduleName="Students"
            header="List Users"
            activityName="list-students"
          />
        }
      ></ModalWindow>

      <ModalWindow
        modal={filterModal}
        toggleModal={() => setFilterModal((prev) => !prev)}
        modalHeader={"Students Filter"}
        size="lg"
        modalBody={
          <FilterStudentModal
            filterData={filterData}
            setFilterData={setFilterData}
            classroom={classroom}
            handleFilterFormSubmit={handleFilterFormSubmit}
          />
        }
      />
    </>
  );
};

export default StudentsList;
